import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faBell,
  faComments,
  faFrown,
  faClipboard,
  faTimesCircle,
  faEdit,
  faCalendarCheck,
  faWindowMinimize,
  faWindowMaximize,
  faPauseCircle,
  faQuestionCircle,
  faRegistered
} from '@fortawesome/free-regular-svg-icons'

library.add(
  faComments,
  faBell,
  faFrown,
  faClipboard,
  faTimesCircle,
  faEdit,
  faCalendarCheck,
  faWindowMinimize,
  faWindowMaximize,
  faPauseCircle,
  faQuestionCircle,
  faRegistered
)
